var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeopleProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.947 30.9h-2c0-5.8 7.6-8.8 10-9.6V18h2v4.8l-.7.2c-.1 0-9.3 2.6-9.3 7.9z",
    fill: "#0073F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.947 21c-.6 0-1-.4-1-1v-1.5c-1.9-1.5-3-3.9-3-6.5V8c0-4.4 3.6-8 8-8s8 3.6 8 8v4c0 4.4-3.6 8-8 8-.6 0-1-.4-1-1s.4-1 1-1c3.3 0 6-2.7 6-6V8c0-3.3-2.7-6-6-6s-6 2.7-6 6v4c0 2.1 1 4.1 2.6 5.2l.4.3V20c0 .6-.4 1-1 1z",
    fill: "#0073F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.947 18h-2v4h2v-4z",
    fill: "#0073F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.947 30.9c0-5.3-9.2-7.9-9.2-7.9l-.8-.2V18h2v3.3c2.4.8 10 3.8 10 9.6h-2zm-27 5.1v6h28v-6h-28zm28-2c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-28c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h28zm-21 4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm4 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm15 0h-10v2h10v-2zm-23 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z",
    fill: "#0073F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.947 21h3m-36 10h45-45zm33-14h8-8zm0-4h3-3z",
    stroke: "#0073F7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.947 18v-2h8v2h-8zm5-4v-2h3v2h-3zm0 8v-2h3v2h-3z",
    fill: "#0073F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.947 6v40c0 1.1-.8 1.9-1.9 2h-44.1c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16v2h-16v40h44V6h-15V4h15c1.1 0 2 .9 2 2z",
    fill: "#0073F7"
  })));
}

export default SvgPeopleProfile;